import React, { useCallback, useContext, useEffect, useState } from "react";
import useLabels from "../../../../../customHooks/useLabels";
import { GetVendorNotes } from "../queries/query";
import { GetVendorNotesResult, GetVendorNotesVars } from "../queries/types";
import { useLazyQuery } from "@apollo/client";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import { AppContext } from "../../../../../context/context";
import { empType } from "../../../../../utils/Enum.types";
import { getDownloadUrl } from "../../../../../utils/DownloadFile";
import Pdf from "../../../../../images/DownloadPdf.svg";
import DownloadImage from "../../../../../images/DownloadImage.svg";
import Doc from "../../../../../images/WordDocument.svg";
import Xls from "../../../../../images/Excel.svg";
import { EMPTY_STRING } from "../../../../../utils/constants";
import { CustomModal } from "../../../../../utils/UtilFunctions";
import { ViewMoreFileStyles } from "../../../../../styles/CustomModalStyles";
import { Title } from "../../../../../stories/Title/Title";
import Close from "../../../../../images/Close.svg";
import { Button } from "../../../../../stories/Button/Button";
interface Props
{
  momID: number,
  latest: boolean;
}
const ViewVendorNotes = ( { momID, latest }: Props ) =>
{
  const { ledgerLabel } = useLabels();
  const { state } = useContext( AppContext );
  const { customer_id, projectID } = useUrlParams();

  const [ attachmentId, setAttachmentId ] = useState( 0 );
  const [ vendorFilesModal, setVendorFilesModal ] = useState( false );

  const [ commentFiles, stCommentFiles ] = useState<string[]>( [] );
  const [ GetNotes, { data } ] = useLazyQuery<
    GetVendorNotesResult,
    GetVendorNotesVars
  >( GetVendorNotes );

  useEffect( () =>
  {
    if ( customer_id && momID && projectID )
    {
      GetNotes( {
        variables: {
          customerID: customer_id,
          momID,
          projectID,
          latest
        }
      } );
    }
  }, [ GetNotes, momID, projectID, customer_id, latest, state.empSubType ] );
  const downloadFile = ( ext: string, index: number, commentId: number ) =>
  {
    const filename = `${ customer_id }/momDetails/${ momID }/${ projectID }/vendorNotes/${ commentId }_${ index }.${ ext }`;
    getDownloadUrl( filename, true );
  };

  const chooseFile = useCallback(
    ( file: string, index: number, commentId: number ) =>
    {
      const ext = file.split( "." ).pop();

      const ReturnComp = ( { image }: { image: string } ) =>
      {
        return (
          <div
            className="meeting-details--left--block--attachments--file"
            onClick={() => downloadFile( ext!, index, commentId )}
          >
            <span> {file}</span> <img src={image} alt="not found" />
          </div>
        );
      };
      switch ( ext )
      {
        case "jpg":
        case "jpeg":
        case "png":
          return <ReturnComp image={DownloadImage} />;
        case "doc":
        case "docx":
          return <ReturnComp image={Doc} />;
        case "xlsx":
        case "xls":
        case "csv":
          return <ReturnComp image={Xls} />;
        case "pdf":
          return <ReturnComp image={Pdf} />;
        default:
          return <></>;
      }
    },
    []
  );

  const chooseFileMore = useCallback(
    (
      file: string,
      index: number,
      commentId: number,
    ) =>
    {
      const ext = file.split( "." ).pop();

      const ReturnComp = ( { image }: { image: string } ) =>
      {
        return (
          <>
            <div
              className="meeting-details--left--block--attachments--file"
              onClick={() => downloadFile( ext!, index, commentId, )}
            >
              <span> {file}</span> <img src={image} alt="not found" />
            </div>
          </>
        );
      };
      switch ( ext )
      {
        case "jpg":
        case "jpeg":
        case "png":
          return <ReturnComp image={DownloadImage} />;
        case "doc":
        case "docx":
          return <ReturnComp image={Doc} />;
        case "xlsx":
        case "xls":
        case "csv":
          return <ReturnComp image={Xls} />;
        case "pdf":
          return <ReturnComp image={Pdf} />;
        default:
          return <></>;
      }
    },
    []
  );


  if ( data && data.GetVendorNotes.length )
  {
    return (
      <>
        <b className="meeting-details--left--block--vendor">
          {ledgerLabel} Points to Notice
        </b>
        {/* <ul className="view-notes__block--header--view">
          {Header.filter((res) => res !== "Response").map((res, index) => {
            return <li key={index}>{res}</li>;
          })}
        </ul> */}
        <div className="view-notes__block--sub">
          <ul>
            {data
              ? data.GetVendorNotes.map( ( vendor_notes, index ) =>
              {
                let vendorFiles: string[] = [];
                let vendorVisibleFiles: string[] = [];
                let vendorRemainingCount = 0;

                if (
                  vendor_notes.vendorNotesDocuments.trim() !== EMPTY_STRING
                )
                {
                  vendorFiles = vendor_notes.vendorNotesDocuments.split( ";" );
                  vendorVisibleFiles = vendorFiles.slice( 0, 2 );
                  vendorRemainingCount = vendorFiles.length - 2;
                }
                return (
                  <li
                    className="view-notes__block--list--view"
                  >
                    <span className="meeting-details--left--block--slno">
                      {index + 1} .
                    </span>

                    <div className="meeting-details--left--block--attachments">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: vendor_notes.vendorNotes
                        }}
                      />

                      <div >
                        {vendorVisibleFiles.map( ( file, i ) =>
                        {
                          const filename = file.split( "/" ).pop();
                          return (
                            <div key={i}>
                              {chooseFile( filename!, index, vendor_notes.id )}
                            </div>
                          );
                        } )}

                        {vendorRemainingCount > 0 && (
                          <button
                            onClick={() =>
                            {
                              setAttachmentId( vendor_notes.id );
                              stCommentFiles(
                                vendor_notes.vendorNotesDocuments.split( ";" )
                              );
                              setVendorFilesModal( !vendorFilesModal );
                            }}
                          >
                            +{vendorRemainingCount} more
                          </button>
                        )}
                      </div>

                      <CustomModal
                        style={ViewMoreFileStyles}
                        isOpen={vendorFilesModal}
                        onRequestClose={() =>
                          setVendorFilesModal( !vendorFilesModal )
                        }
                        contentComponent={
                          <div className="meeting-details--left--block--more-files">
                            <div className="meeting-details--left--block--more-files-t">
                              <Title>Uploaded Files</Title>
                              <img
                                src={Close}
                                alt=""
                                onClick={() =>
                                  setVendorFilesModal( !vendorFilesModal )
                                }
                              />
                            </div>
                            <div className="meeting-details--left--block--more-files--block">
                              <ul>
                                {commentFiles.map( ( files, index ) =>
                                {
                                  const filename = files.split( "/" ).pop();

                                  return (
                                    <li key={index}>
                                      {chooseFileMore(
                                        filename!,
                                        index,
                                        attachmentId
                                      )}
                                    </li>
                                  );
                                } )}
                              </ul>
                            </div>
                            <Button
                              mode="cancel"
                              onClick={() =>
                                setVendorFilesModal( !vendorFilesModal )
                              }
                            />
                          </div>
                        }
                      />
                    </div>

                    {/* {res.response.emp_details.map((emp, index) => {
              return (
                <div>
                  <div className="meeting-details--left--block--emp-details">
                    <img src={emp.img} alt="" />
                    <b>{emp.name}</b>
                    <span>({emp.desn})</span>
                  </div>
                  <b>{emp.details}</b>
                </div>
              );
            })} */}
                  </li>
                );
              } )
              : null}
          </ul>
        </div>
      </>
    );
  }

  return <></>;
};

export default ViewVendorNotes;
